import type { EditorMessage } from "./RendererBridgePort";
import { isWholeNumber } from "./wholeNumber";

// The editor's readHomeUntil: it has no cache version for the renderer's reads to wait for, so until this time
// (Date.now()'s clock) they go to Frankfurt. Its until must be a whole number of 0 or more, as the contract says;
// anything else is refused, as readAfter's cacheSeq is.
function parse(message: Readonly<Record<string, unknown>>): EditorMessage<"readHomeUntil"> {
  const until = message["until"];
  if (!isWholeNumber(until)) throw new Error("readHomeUntil's until is not a whole number of 0 or more");
  return { type: "readHomeUntil", until };
}

export const EditorReadHomeUntil = { parse } as const;
